import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "paddingInline", "textAlign"];
import { LayoutBox } from './Layout/LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
export const CardContentWrapper = _ref => {
  let {
      children,
      paddingInline = 'space-lg',
      textAlign = 'left'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
    marginBlockStart: "-space-xxxs",
    paddingInline: paddingInline,
    textAlign: textAlign,
    children: children
  }));
};